import crews from "csi/access/crews";
import { REVISION_DRAFT } from "csi/reflection/reflectionConstants";
import { routerStore } from "csi/state/rootStore";
import ToolbarPluginButton from "csi/view/ToolbarPluginButton";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const FOOD_LABEL_DATA_SHEET_REVISION = "FoodLabelDataSheetRevision";

const RefreshLabelItemsPlugin = declare(ToolbarPluginButton, {
	/**
	 * @override
	 * hide the "Refresh from Recipe" and "Refresh {FoodLabelItem}" buttons if FoodLabel was not copied from a recipe
	 * and if the user does not have sufficient role permissions
	 */
	validatePlugin(ctx) {
		let showAction = false;
		const revisionNode = routerStore.locationRevisionNode;
		if (revisionNode?.$Type === FOOD_LABEL_DATA_SHEET_REVISION) {
			const foodLabelNode = ctx.cache.getNode(revisionNode.__Parent__);
			showAction = xml.isValidURL(foodLabelNode.CopiedFromBOM);
		}

		if (showAction && ctx.defView.getId() === "__Breadcrumb__") {
			showAction = crews.isInRoles(["Product Specification Administrator", "Product Specification Editor", "TDS - Food Label Administrator", "TDS - Food Label Creator", "TDS - Food Label Editor"]);
		}
		return showAction;
	},

	/**
	 * @override
	 * disable the "Refresh from Recipe" and "Refresh {FoodLabelItem}" buttons if FoodLabel revision in view is not DRAFT
	 */
	enablePlugin(ctx) {
		const revisionNode = routerStore.locationRevisionNode;
		if (revisionNode?.$Type === FOOD_LABEL_DATA_SHEET_REVISION) {
			this._setDisabled(this, revisionNode.State != REVISION_DRAFT); 
		}
	},
});

export = RefreshLabelItemsPlugin;